<div class="users">
    <lsq-circle-loader *ngIf="isFetchingUserDetails"></lsq-circle-loader>

    <div
        *ngIf="!isFetchingUserDetails"
        class="active-users"
        [ngClass]="{ hideImpersonateColumn: isProspectView }"
    >
        <div class="users-section-header first-section">
            <div>
                <div class="title" i18n="Active users header">Active Users</div>
                <div class="description" i18n>
                    These are the active users on the platform for this company.
                </div>
            </div>
            <lsq-button
                *ngIf="isNotAdminCompany || canManageAdminCompanies"
                class="section-heading-action-btn"
                appearance="secondary"
                (buttonClick)="addNewUser()"
                i18n="Invite new user button"
            >
                Invite User
            </lsq-button>
        </div>

        <users-table
            [canEditPermissions]="isNotAdminCompany || canManageAdminCompanies"
            [isAdmin]="isAdmin"
            [dataSource]="activeDataSource"
            [allowImpersonate]="!isProspectView"
            (manageUser)="manageUser($event)"
            (activateUser)="activateConfirmDialog($event)"
            (deactivateUser)="deactivateConfirmDialog($event)"
            (reinviteUser)="reinviteUser($event)"
            (impersonateUser)="impersonate($event)"
        ></users-table>
    </div>

    <div *ngIf="showPendingUsers && !isFetchingUserDetails" class="pending-users">
        <div class="users-section-header">
            <div>
                <div class="title" i18n="Active users header">Pending Users</div>
                <div class="description" i18n>
                    These users have been invited to join this company.
                </div>
            </div>
        </div>

        <users-table
            [canEditPermissions]="isNotAdminCompany || canManageAdminCompanies"
            [isAdmin]="isAdmin"
            [dataSource]="pendingDataSource"
            [allowImpersonate]="!isProspectView"
            (manageUser)="manageUser($event)"
            (activateUser)="activateConfirmDialog($event)"
            (deactivateUser)="deactivateConfirmDialog($event)"
            (reinviteUser)="reinviteUser($event)"
            (impersonateUser)="impersonate($event)"
        ></users-table>
    </div>

    <div *ngIf="showInactiveUsers && !isFetchingUserDetails" class="inactive-users">
        <div class="users-section-header">
            <div>
                <div class="title" i18n="Active users header">Inactive Users</div>
                <div class="description" i18n>
                    These users have been deactivated from this company.
                </div>
            </div>
        </div>

        <users-table
            [canEditPermissions]="isNotAdminCompany || canManageAdminCompanies"
            [isAdmin]="isAdmin"
            [dataSource]="inactiveDataSource"
            [allowImpersonate]="!isProspectView"
            (manageUser)="manageUser($event)"
            (activateUser)="activateConfirmDialog($event)"
            (deactivateUser)="deactivateConfirmDialog($event)"
            (reinviteUser)="reinviteUser($event)"
            (impersonateUser)="impersonate($event)"
        ></users-table>
    </div>
</div>
